export default "__VITE_ASSET__Cj7uN5II__"